/**
 * Application event class definitions
 *
 * This file defines all global events that can be emitted through the EventBus.
 * Each event is a class that can be instantiated with or without a payload.
 */

/**
 * Base class for all application events
 */
export abstract class AppEvent<T = undefined> {
  /** Unique event type identifier */
  abstract readonly type: string;

  /** Timestamp when event was created */
  readonly timestamp: number;

  /** Event payload data (if any) */
  readonly payload: T;

  protected constructor(payload: T) {
    this.timestamp = Date.now();
    this.payload = payload;
  }
}
